export class AicraftHelper {
    public static COMMERCIAL_AIRCRAFT_FLIGHT_NUMBER = [
        'AAL',
        'AAY',
        'ACA',
        'AIJ',
        'AMF',
        'AMX',
        'ANA',
        'ASA',
        'ASH',
        'ATN',
        'AWI',
        'BAW',
        'DAL',
        'DLH',
        'EDV',
        'ENY',
        'FDX',
        'FFT',
        'GDP',
        'GEC',
        'HAL',
        'JBU',
        'JIA',
        'JSX',
        'KAP',
        'KLM',
        'MTN',
        'NKS',
        'PDT',
        'POE',
        'QTR',
        'QXE',
        'ROU',
        'RPA',
        'SCX',
        'SIL',
        'SKW',
        'SNC',
        'SWA',
        'SWG',
        'TSC',
        'UAE',
        'UAL',
        'UCA',
        'UPS',
        'VIV',
        'VOI',
        'WAF',
        'WJA',
        'LRC',
        'TAI',
        'GLG',
        'VTE',
        'AVA',
        'MXY',
        'MX',
        'VOS'
    ];

   public static COMMERCIAL_COMPANY_NAME = [
        'DELTA AIRLINES INC',
        'DELTA AIR LINES INC',
        'REPUBLIC AIRWAYS INC',
        'JETBLUE AIRWAYS CORP',
        'JET BLUE AIRWAYS CORP',
        'HYANNIS AIR SERVICE INC',
        'SOUTHWEST AIRLINES CO',
        'UNITED AIRLINES INC',
        'ALASKA AIRLINES INC'
    ];

    public static COMMERCIAL_AIRCRAFT_TYPE = [
        'A32N',
        'B738'
    ];
    // in swims this is ICAOAircraftCode
    public static isCommercialAircraftCode = (aircraftCode: string): boolean => {
        return this.COMMERCIAL_AIRCRAFT_TYPE.includes(aircraftCode?.toUpperCase());
    }
    
    public static isCommercialCompanyRegex = (companyName: string): boolean => {
        if (!companyName)
            return false;
        companyName = companyName.toUpperCase();
        
        const regrexToMatch = ["AIR*", "AIRWAYS"];
        
        return regrexToMatch.some((regex) => {
            const pattern = new RegExp(regex, 'i');
            return pattern.test(companyName);
        });
    }
    public static isCommercialFlightNumber = (flightNumber: string): boolean => {
        if (!flightNumber)
            return false;
        return this.COMMERCIAL_AIRCRAFT_FLIGHT_NUMBER.some((startNum) =>
            flightNumber?.toUpperCase().startsWith(startNum)
        );
    }

    public static isCommercialCompanyName = (companyName: string): boolean => {
        if (!companyName)
            return false;
        companyName = companyName.toUpperCase();
        
        return this.COMMERCIAL_COMPANY_NAME.some((comercialCompanyName) =>
            companyName?.includes(comercialCompanyName)
        );
    }   
        
    public static isCommercialAircraft = (flightNumber: string, companyName:string = null, ICAOAircraftCode:string = null) : boolean => {
        return this.isCommercialFlightNumber(flightNumber) || 
        (!companyName || this.isCommercialCompanyName(companyName)) || 
        ((!ICAOAircraftCode || this.isCommercialAircraftCode(ICAOAircraftCode)) && 
        !companyName ||this.isCommercialCompanyRegex(companyName));
    }

    public static hasCommercialAicraftInFlightNumberList = (flightNumbers: string[]): any[] => {
        return this.COMMERCIAL_AIRCRAFT_FLIGHT_NUMBER.filter((startNum) => (
            flightNumbers.some(f => f.toUpperCase().startsWith(startNum))));
    }
    public static hasCommercialAircraftInCompanyNameList = (companyNames: string[]): any[] => {
        return this.COMMERCIAL_COMPANY_NAME.filter((comercialCompanyName) => (
                companyNames.some(c => c.toUpperCase().includes(comercialCompanyName)
            )));
    }
    public static isCommercialAircraftInFlightNumbers = (flightNumbers: string[], companyNames: string[] = []): boolean => {
        if (!flightNumbers)
            return false;
        if (flightNumbers.length == 0)
            return false;

        var matches = this.hasCommercialAicraftInFlightNumberList(flightNumbers) ||
            this.hasCommercialAircraftInCompanyNameList(companyNames);

        return (matches && matches.length > 0);
    }
}
     
